import React from "react";
import { useTranslation } from "react-i18next";
import { useAppNotifications } from "@planzone/view-models";

import { NotificationWrapper } from "../notificationWrapper";
import { Props } from "./types";
import styles from "./styles.scss";

function Notifications(props: Props) {
  const { t } = useTranslation();
  const { notifications, canDisplayNotifications, dismissNotification } =
    useAppNotifications();

  return canDisplayNotifications ? (
    <div className={styles.notifications}>
      <div className={styles.main}>
        <ul className={styles.messageList}>
          {notifications.map((notification) => (
            <li key={notification.key} className={styles.item}>
              <NotificationWrapper
                lifeTimeInMs={props.notificationsLifeTimeInMs}
                messages={
                  !!notification.args.message
                    ? [notification.args.message]
                    : notification.flags.reduce<string[]>(
                        (acc, flag) => [
                          ...acc,
                          t(
                            `appNotifications.${notification.key}.${flag}`,
                            notification.args,
                          ),
                        ],
                        [],
                      )
                }
                isSuccess={!!notification.args.success}
                isWarning={!!notification.args.failure}
                dismissNotification={() =>
                  dismissNotification(notification.key)
                }
              />
            </li>
          ))}
        </ul>
      </div>
    </div>
  ) : null;
}

export { Notifications };
